import { SelectTheme } from '@kite-js/theme';

const select: SelectTheme = {
    px: 'S',
    py: 'S',
    border: 'S',
    borderRadius: 'NONE',
};

export default select;
